import { useEffect, useState } from 'react'
import { useTheme, isDarkNow } from '@/stores/theme'

/**
 * The app icon as a sticker: the jelly cat with a heart by day, the same cat
 * glowing among stars by night.
 */
export function AppMark({ size = 108 }: { size?: number }) {
  const preference = useTheme((s) => s.preference)
  const [dark, setDark] = useState(() => isDarkNow())

  useEffect(() => {
    setDark(isDarkNow())
    const media = window.matchMedia('(prefers-color-scheme: dark)')
    const onChange = () => setDark(isDarkNow())
    media.addEventListener('change', onChange)
    return () => media.removeEventListener('change', onChange)
  }, [preference])

  return (
    <img
      className="auth__icon"
      src={dark ? '/illustrations/cat-night.jpg' : '/illustrations/cat-heart.jpg'}
      alt=""
      width={size}
      height={size}
      style={{ width: size, height: size }}
      decoding="async"
    />
  )
}
